<script setup lang="ts">
import SettingBillingView from '../../views/SettingBillingView/SettingBillingView.vue';
import UserAuthPageDecoration from 'src/shared/components/UserAuthPageDecoration/UserAuthPageDecoration.vue';
import { useQuasar } from 'quasar';
import { styleFn } from 'shared/composables/usePage';
import type { UserRole } from 'src/types/User';
import { inject } from 'vue';

const userRole = inject('currentUserRole') as UserRole;
const $q = useQuasar();
// interface Props {
//   // modelValue: string
// }

// defineProps<Props>()
</script>

<template>
  <q-page
    padding
    :style-fn="styleFn"
    class="column relative-position"
    :class="{
      'bg-dark': userRole !== 'child',
    }"
  >
    <div class="col fit bg-dark relative-position">
      <setting-billing-view class="relative-position z-100" />
      <UserAuthPageDecoration v-if="!$q.platform.is.mobile" />
    </div>
  </q-page>
</template>
